import React from "react"
import classnames from "classnames"

import * as styles from "./GridText.module.css"

const getElementGap = (numberOfChildren: number) => {
  switch (numberOfChildren) {
    case 1:
      return "5%"
    case 2:
      return "5%"
    case 3:
      return "2%"
    default:
      return "1%"
  }
}

export const GridTextContainer = ({
  children,
  lineHeight,
  mobileReverseOrder,
  style,
  gap,
}: {
  children: React.ReactNodeArray
  lineHeight?: number
  style?: React.CSSProperties
  mobileReverseOrder?: boolean
  gap?: string
}) => {
  return (
    <div
      className={classnames(styles.gridTextContainer, {
        [styles.mobileReverseOrder]: mobileReverseOrder,
      })}
      style={{
        ...style,
        ["--number-of-children" as any]: children.length,
        ["--line-height" as any]: `${lineHeight}px` || "normal",
        ["--elementGap" as any]: gap || getElementGap(children.length),
      }}
    >
      {children}
    </div>
  )
}

type Alignment = "center" | "top" | "bottom" | "left" | "right" | "stretch"

const getAlignmentToFlexAlignment = (x: Alignment) => {
  switch (x) {
    case "center":
      return "center"
    case "top":
    case "left":
      return "flex-start"
    case "bottom":
    case "right":
      return "flex-end"
    case "stretch":
      return "stretch"
    default:
      return undefined
  }
}

export const GridText = ({
  children,
  align: alignV = "top",
  HAlign = "left",
  selfVAlign,
  selfCenter,
  gap,
}: {
  children: React.ReactNodeArray
  align?: Alignment
  selfVAlign?: Alignment | "stretch"
  HAlign?: "center" | "right" | "left"
  selfCenter: boolean
  gap?: number
}) => (
  <div
    className={classnames(styles.gridText, "grid-text")}
    data-role="grid-text"
    style={{
      justifyContent: getAlignmentToFlexAlignment(alignV),
      alignItems: getAlignmentToFlexAlignment(HAlign),
      alignSelf: selfVAlign && getAlignmentToFlexAlignment(selfVAlign),
      margin: selfCenter ? "0 auto" : undefined,
      gap,
    }}
  >
    {children}
  </div>
)
